import * as React from 'react';

interface DynamicFormProps {
  children: React.ReactElement | React.ReactElement[];
  onChange?: (value: Object) => void;
}

export default function DynamicForm(props: DynamicFormProps) {
  const [values, setValues] = React.useState<Object>({});
  const [valid, setValid] = React.useState<
    { [key: string]: boolean } | undefined
  >();
  const [changedVal, setChangedVal] = React.useState<{
    name: string;
    value: any;
    valid: boolean;
  }>({ name: '', value: '', valid: true });

  const validChildren: { [key: string]: boolean } = {};
  const defaultValues: { [key: string]: any } = {};

  const findNamedChildren = (el: any) => {
    let elChildren: any[] = [];
    if (el.props?.children) {
      elChildren = Array.isArray(el.props.children)
        ? el.props.children
        : [el.props.children];
    } else if (el.children) {
      elChildren = Array.from(el.children);
    }
    elChildren = elChildren.map((child) => {
      const newChildren = findNamedChildren(child);
      let newChild = child;
      if (newChildren.length > 0) {
        newChild = React.cloneElement(child, {
          ...child.props,
          children: newChildren
        });
      }
      if (child.name || child.props?.name) {
        const name = child.name || child.props?.name;

        newChild = React.cloneElement(newChild, {
          ...newChild.props,
          onChange: (e: any) => {
            if (child.props.onChange) {
              child.props.onChange(e);
            }
            let value;
            if (e.target?.type === 'checkbox' || e.target?.type === 'radio') {
              const newVal = e.target.value;
              value = e.target.checked ? newVal : undefined;
            } else if (e.target?.value) {
              value = e.target.value;
            } else if (e.value) {
              value = e.value;
            }
            setChangedVal({
              name,
              value,
              valid: !(
                e.valid === false ||
                e.target?.valid === false ||
                e.target?.validity?.valid === false
              )
            });
          }
        });
        if (child.props?.required) {
          let isValid = !!child.props.value;
          if (child.type?.name === 'CheckBox') {
            isValid = !!child.props.checked;
          }
          validChildren[name] = isValid;
        }
        if (child.props?.value) {
          let { value } = child.props;
          if (child.type?.name === 'CheckBox') {
            value = child.props.checked ? child.props.value : undefined;
          }
          defaultValues[name] = value;
        }
      }
      return newChild;
    });
    return elChildren;
  };

  React.useEffect(() => {
    setValid(validChildren);
    setValues(defaultValues);
  }, []);

  React.useEffect(() => {
    if (changedVal.name) {
      const newValues: { [key: string]: any } = {
        ...values,
        [changedVal.name]: changedVal.value
      };
      const newValid: { [key: string]: boolean } = {
        ...valid,
        [changedVal.name]: changedVal.valid
      };
      setValues(newValues);
      setValid(newValid);
    }
  }, [changedVal]);

  React.useEffect(() => {
    if (props.onChange && valid !== undefined) {
      const allValid = valid ? !Object.values(valid).includes(false) : false;
      props.onChange({ values: { ...values }, valid: allValid });
    }
  }, [valid]);

  return (
    <div className="dynamic-form">
      {findNamedChildren(<div>{props.children}</div>)}
    </div>
  );
}
